import { render, staticRenderFns } from "./AkbsWage.vue?vue&type=template&id=28c82611&scoped=true&"
import script from "./AkbsWage.vue?vue&type=script&lang=js&"
export * from "./AkbsWage.vue?vue&type=script&lang=js&"
import style0 from "./AkbsWage.vue?vue&type=style&index=0&id=28c82611&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c82611",
  null
  
)

export default component.exports